import { render, staticRenderFns } from "./FeaturedCollection.vue?vue&type=template&id=f0acf4e2&scoped=true&"
import script from "./FeaturedCollection.vue?vue&type=script&lang=ts&"
export * from "./FeaturedCollection.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturedCollection.vue?vue&type=style&index=0&id=f0acf4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0acf4e2",
  null
  
)

component.options.__file = "FeaturedCollection.vue"
export default component.exports